module.exports = __webpack_public_path__ + "static/media/thotcon.3c64d88d.png";